export default function addRowPriorityClass(event) {
  if (event.rowType === 'data' && Number.isInteger(event.data.priority)) {
    event.rowElement.classList.add(`dx-row-priority-${event.data.priority}`);
  }
}
